import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {AsyncSubject, Observable} from 'rxjs';
import {AdvertisingPlatform} from '../../models/advertising-platform';

@Injectable({
  providedIn: 'root'
})
export class AdvertisingPlatformService extends AbstractModelService<AdvertisingPlatform> {

  private advertisingPlatforms = new AsyncSubject<AdvertisingPlatform[]>();

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/advertising-platform', AdvertisingPlatform);

    this.findAll().subscribe(advertisingPlatforms => {
      this.advertisingPlatforms.next(advertisingPlatforms);
      this.advertisingPlatforms.complete();
    });
  }

  getList(): Observable<AdvertisingPlatform[]> {
    return new Observable<AdvertisingPlatform[]>(observer => {
      this.advertisingPlatforms.subscribe((advertisingPlatforms) => {
        observer.next(advertisingPlatforms);
        observer.complete();
      });
    })
  }
}
